import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import { connect } from '../../Store';

const Wrapper = styled.div`
  margin: 0 15px;
  display: flex;
`;

const P = styled.p`
  font-weight: 300;
  cursor: pointer;
`;

const Pu = styled(P)`
  text-decoration: underline;
  font-weight: 450;
`;

class HeaderFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return this.props.values.map(v => {
      return this.props.state === v ? (
        <Wrapper>
          <Pu onClick={e => this.props.onClick(e.target.innerText)}>{v}</Pu>
        </Wrapper>
      ) : (
        <Wrapper>
          <P onClick={e => this.props.onClick(e.target.innerText)}>{v}</P>
        </Wrapper>
      );
    });
  }
}

HeaderFilter.propTypes = {
  state: propTypes.string,
  values: propTypes.objectOf(propTypes.any),
  onClick: propTypes.func,
};

HeaderFilter.defaultProps = {
  state: '',
  values: [],
  onClick: () => {},
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(HeaderFilter);



// WEBPACK FOOTER //
// ./src/Components/HeaderFilter/index.js